"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VueSlickgridColumnSelector = void 0;
const _ = __importStar(require("lodash"));
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const VueSlickgridColumnSelector_html_1 = __importDefault(require("./VueSlickgridColumnSelector.html"));
const helpers_1 = require("./helpers");
const bootstrap_vue_1 = require("bootstrap-vue");
let VueSlickgridColumnSelector = class VueSlickgridColumnSelector extends vue_1.default {
    $refs;
    isOpen;
    items;
    grid;
    columns;
    messages;
    data() {
        return {
            isOpen: false,
            items: []
        };
    }
    get checkboxItems() {
        return _.filter(this.items, { show: true });
    }
    getItems() {
        const currentColumns = this.grid.getColumns();
        return _.map(this.columns, (col, idx) => {
            const i = _.findIndex(currentColumns, p => p.id === col.id);
            return {
                displayIndex: i,
                columnIndex: idx,
                name: col.name,
                show: !(0, helpers_1.isSystemColumn)(col),
                visible: i > -1,
                column: i > -1 ? currentColumns[i] : col
            };
        });
    }
    applyChanges() {
        this.grid.setColumns(_.chain(this.items)
            .filter(item => item.visible || (0, helpers_1.isSystemColumn)(item.column))
            .sortBy(item => item.displayIndex > -1
            ? item.displayIndex
            : item.columnIndex + this.items.length)
            .map(col => col.column)
            .value());
        this.$nextTick(() => this.close());
    }
    close() {
        this.$refs.dropdown.hide(true);
    }
    onShown() {
        this.items = this.getItems();
    }
};
exports.VueSlickgridColumnSelector = VueSlickgridColumnSelector;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], VueSlickgridColumnSelector.prototype, "grid", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Array)
], VueSlickgridColumnSelector.prototype, "columns", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], VueSlickgridColumnSelector.prototype, "messages", void 0);
exports.VueSlickgridColumnSelector = VueSlickgridColumnSelector = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: VueSlickgridColumnSelector_html_1.default,
        components: {
            BDropdown: bootstrap_vue_1.BDropdown,
            BDropdownForm: bootstrap_vue_1.BDropdownForm,
            BFormCheckbox: bootstrap_vue_1.BFormCheckbox,
            BFormGroup: bootstrap_vue_1.BFormGroup,
            BButton: bootstrap_vue_1.BButton
        }
    })
], VueSlickgridColumnSelector);
//# sourceMappingURL=VueSlickgridColumnSelector.js.map